import { render, staticRenderFns } from "./relationships.vue?vue&type=template&id=8a8923b0&scoped=true"
import script from "./relationships.vue?vue&type=script&lang=js"
export * from "./relationships.vue?vue&type=script&lang=js"
import style0 from "./relationships.vue?vue&type=style&index=0&id=8a8923b0&prod&ref=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8923b0",
  null
  
)

export default component.exports